import React, { ChangeEvent } from "react";
import * as app from "../services/AppService";
interface Props { 
    onChange: (...args:any) => any,
    title?: string,
    id?:string
}
export default function FileUpload(props: Props) {

    function readURL(event:ChangeEvent<HTMLInputElement>) {
        var input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                if (props.onChange && typeof (props.onChange) == "function")
                    //@ts-ignore
                    props.onChange(e.target?.result?.split("base64,")[1], input.files?.[0]?.name)
            };
            reader.readAsDataURL(input.files[0]);
            const fileChosen = document.getElementById("fileChosen")!;
            fileChosen.textContent = input.files?.[0]?.name;
        }
    }

    return (
        <>
            <label className=" form-control" htmlFor={"file-upload-input" + props.title}>
                {app.translate(props.title)}
                <span className="iconssc-cloud ms-2"></span>
                <span id="fileChosen" className=""></span>
            </label>
            <input className="d-none"
                id={props.id ? props.id : "file-upload-input" + (props.title||"")}
                type='file' onChange={readURL} accept=".xlsx,.xls" />
            
        </>
    );
}


FileUpload.defaultProps = {
    title: "",
};
